<h4 class="header">Data Source Categories</h4>
<div class="container">
    <mat-checkbox [disabled]="true" [checked]="isCheckedCity">City</mat-checkbox>
    <mat-checkbox [disabled]="true" [checked]="isCheckedCounty">County</mat-checkbox>
    <mat-checkbox [disabled]=" true" [checked]="isCheckedState">State</mat-checkbox>
</div>